module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor18-f0e3fb9215a8daa4f41d4c0a06eae7d5.pdf";